import React from 'react';
import Header from "../Components/Header.js";
import Contact from "../Components/Contact.js";
import Footer from "../Components/Footer.js";
import AllArticles from "../Components/AllArticles.js";
import "../Components/AllArticles.css";

const Articles = () => {
    return (
        <div className="articles-container">
          <div className="page-content">
        <Header />
        <AllArticles />
        </div>
        <div className="page-footer">
        <Contact />
        <Footer />
       </div>
        </div>
    );
  };

export default Articles;
